/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Faq_Improve_AInputs */

const en_directory_hubs_signals_faq_improve_a = /** @type {(inputs: Directory_Hubs_Signals_Faq_Improve_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with the Learn stage — docs, quickstart, and an OpenAPI spec are the cheapest, highest-leverage fixes. Then expose machine interfaces (MCP, non-interactive CLI), and make results verifiable with structured output. Each check lifts the underlying benchmark dimensions.`)
};

const zh_directory_hubs_signals_faq_improve_a = /** @type {(inputs: Directory_Hubs_Signals_Faq_Improve_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从“学习”阶段入手——文档、快速上手和 OpenAPI 规范是性价比最高的改进。然后暴露机器接口（MCP、非交互 CLI），并用结构化输出让结果可验证。每一项检查都会提升底层的基准维度。`)
};

/**
* | output |
* | --- |
* | "Start with the Learn stage — docs, quickstart, and an OpenAPI spec are the cheapest, highest-leverage fixes. Then expose machine interfaces (MCP, non-interac..." |
*
* @param {Directory_Hubs_Signals_Faq_Improve_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_faq_improve_a = /** @type {((inputs?: Directory_Hubs_Signals_Faq_Improve_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Faq_Improve_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_faq_improve_a(inputs)
	return zh_directory_hubs_signals_faq_improve_a(inputs)
});
export { directory_hubs_signals_faq_improve_a as "directory.hubs.signals.faq.improve_a" }